import {
  Volleyball, Accessibility, Library, Palette, Users, GraduationCap, Baby,
  PersonStanding, Bot, Heart, Cpu, Music, Leaf, CalendarDays,
  Dumbbell, Bike, Waves, Timer, Target, Sparkles, Swords, Sailboat, Crown,
  Mountain, Gauge, Medal,
} from "lucide-react";

// Icon + accent color per subcategory (matches the mobile app sample cards)
export const SUBCAT_ICONS = {
  athlitikoi: { Icon: Volleyball, color: "text-slate-800" },
  amea: { Icon: Accessibility, color: "text-sky-600" },
  kentra_meletis: { Icon: Library, color: "text-teal-600" },
  eikastikes: { Icon: Palette, color: "text-orange-500" },
  kdap: { Icon: Users, color: "text-amber-500" },
  xenes_glosses: { Icon: GraduationCap, color: "text-indigo-600" },
  vrefonipiakoi: { Icon: Baby, color: "text-pink-500" },
  syllogoi_xoreutikon: { Icon: PersonStanding, color: "text-rose-500" },
  stem: { Icon: Bot, color: "text-sky-600" },
  eidikes_therapeies: { Icon: Heart, color: "text-red-500" },
  robotiki: { Icon: Cpu, color: "text-blue-600" },
  sxoles_mousikis: { Icon: Music, color: "text-violet-600" },
  sxoles_xorou: { Icon: PersonStanding, color: "text-pink-600" },
  proskopismos: { Icon: Leaf, color: "text-green-600" },
  xoroi_ekdiloseon: { Icon: CalendarDays, color: "text-pink-500" },
};

export const DEFAULT_SUBCAT_ICON = { Icon: Sparkles, color: "text-primary" };

// Icon per sport
export const SPORT_ICONS = {
  podosfairo: Volleyball,
  klasikos: Timer,
  basket: Target,
  kolymvisi: Waves,
  gymnastiria: Dumbbell,
  ydatosfairisi: Waves,
  tenis: Target,
  rythmiki: Sparkles,
  volei: Volleyball,
  tzoundo: Swords,
  kopilasia: Sailboat,
  pali: Swords,
  podilasia: Bike,
  skaki: Crown,
  epitr_antisfairisi: Target,
  maxitika: Swords,
  drastiriotites_fysi: Mountain,
  motosikletismos: Gauge,
  ippasia: Medal,
};

const SPORT_PALETTE = [
  "text-sky-600", "text-emerald-600", "text-orange-500", "text-violet-600",
  "text-rose-500", "text-amber-500", "text-teal-600", "text-indigo-600",
];

export const sportColor = (index) => SPORT_PALETTE[index % SPORT_PALETTE.length];
